import { endpoints } from 'Core/defaultValues';

export class CoachingUnreachableError extends Error {
  constructor(cause) {
    super('Coaching host is unreachable');
    this.name = 'CoachingUnreachableError';
    this.cause = cause;
  }
}

// Checks that the Coaching host answers at all. A `no-cors` request resolves with an opaque
// response whenever the host responds (any HTTP status), and rejects only when the browser could
// not reach it (DNS failure, connection refused, offline). That is the one failure the iframe
// cannot report: its `load` event fires on the browser's own error page as if the app had loaded.
export const checkCoachingReachable = async () => {
  try {
    await fetch(endpoints.COACHING_URL, {
      method: 'HEAD',
      mode: 'no-cors',
      credentials: 'omit',
      cache: 'no-store',
    });
    return true;
  } catch (cause) {
    throw new CoachingUnreachableError(cause);
  }
};
